import { supabase } from './supabaseClient';

export const settingService = {
  getAll: async () => {
    try {
      const { data, error } = await supabase
        .from('settings')
        .select('*');
      
      if (error) throw error;
      
      const settings = {};
      data.forEach(item => {
        settings[item.key] = item.value;
      });
      return settings;
    } catch (error) {
      console.error('Error loading settings:', error);
      return getDefaultSettings();
    }
  },

  get: async (key) => {
    try {
      const { data, error } = await supabase
        .from('settings')
        .select('*')
        .eq('key', key)
        .single();
      
      if (error) throw error;
      return data ? data.value : null;
    } catch (error) {
      console.error(`Error loading setting ${key}:`, error);
      return null;
    }
  },

  update: async (key, value) => {
    try {
      // Cek apakah data sudah ada
      const { data: existing, error: findError } = await supabase
        .from('settings')
        .select('id')
        .eq('key', key)
        .maybeSingle();
      
      if (findError) throw findError;
      
      let result;
      if (existing) {
        // UPDATE
        const { data, error } = await supabase
          .from('settings')
          .update({ value, updated_at: new Date().toISOString() })
          .eq('key', key)
          .select();
        
        if (error) throw error;
        result = data;
      } else {
        // INSERT
        const { data, error } = await supabase
          .from('settings')
          .insert({ key, value, updated_at: new Date().toISOString() })
          .select();
        
        if (error) throw error;
        result = data;
      }
      
      console.log(`✅ Setting ${key} updated to:`, value);
      return result;
    } catch (error) {
      console.error(`Error updating setting ${key}:`, error);
      throw error;
    }
  },

  updateBatch: async (settings) => {
    try {
      const results = {};
      for (const [key, value] of Object.entries(settings)) {
        results[key] = await settingService.update(key, value);
      }
      return results;
    } catch (error) {
      console.error('Error updating batch settings:', error);
      throw error;
    }
  },

  // 🔥 getTaxRate dengan logika hybrid
  getTaxRate: async () => {
    try {
      const enabled = await settingService.isTaxEnabled();
      if (!enabled) {
        console.log('ℹ️ Pajak dinonaktifkan oleh user');
        return 0;
      }
      
      const rate = await settingService.get('taxRate');
      
      if (rate === null || rate === undefined) {
        const defaults = getDefaultSettings();
        console.warn('⚠️ Tax rate tidak ditemukan, pakai default:', defaults.taxRate);
        return defaults.taxRate;
      }
      
      const parsedRate = parseFloat(rate);
      if (isNaN(parsedRate)) {
        console.warn('⚠️ Tax rate invalid, pakai default 0%');
        return 0;
      }
      
      return parsedRate;
    } catch (error) {
      console.error('❌ Error getting tax rate:', error);
      const defaults = getDefaultSettings();
      console.warn('⚠️ Error, pakai default tax rate:', defaults.taxRate);
      return defaults.taxRate;
    }
  },

  getTaxName: async () => {
    try {
      const name = await settingService.get('taxName');
      return name || 'PPN';
    } catch (error) {
      console.error('Error getting tax name:', error);
      return 'PPN';
    }
  },

  isTaxEnabled: async () => {
    try {
      const enabled = await settingService.get('taxEnabled');
      if (enabled === null || enabled === undefined) return true;
      return enabled === 'true' || enabled === true;
    } catch (error) {
      console.error('Error checking tax enabled:', error);
      return true;
    }
  }
};

export const getDefaultSettings = () => ({
  taxRate: 11,
  taxName: 'PPN',
  taxType: 'PPN',
  taxEnabled: true
});